import { render, staticRenderFns } from "./delete-account.vue?vue&type=template&id=2530c2a5"
import script from "./delete-account.vue?vue&type=script&lang=js"
export * from "./delete-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.5_webpack@5.110.3__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@5.110.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports